import { HomeownersTrustBelongSection } from 'src/features/homeowners/components/homeowners-trust-belong-section/homeowners-trust-belong-section';

type Props = {
  homeownersCount: number;
};

export const HomeownersCountSlice = ({ homeownersCount }: Props) => {
  return <HomeownersTrustBelongSection homeownersCount={homeownersCount} />;
};
